import { ERROR_MESSAGES } from '../constants';

export const getErrorKey = (error) => {
  const errorNumber = Number(error);

  if (errorNumber >= -1 && errorNumber <= 99) {
    return ERROR_MESSAGES.genericError;
  } else if (errorNumber >= 1000) {
    return ERROR_MESSAGES[errorNumber] ?? ERROR_MESSAGES.genericError;
  } else {
    return ERROR_MESSAGES.genericError;
  }
};
